import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import BroadcastAddList from './components/BroadcastAddList';

const { Cell } = ResponsiveGrid;

const Accounting = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="新增公播"
        breadcrumbs={[
          {
            name: '公播管理',
          },
          {
            name: '新增公播',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <BroadcastAddList />
    </Cell>
  </ResponsiveGrid>
);

export default Accounting;
